export default __webpack_public_path__ + "static/media/workshop.2615c26f.svg";